import { render, staticRenderFns } from "./menubar.vue?vue&type=template&id=8398a294&scoped=true"
import script from "./menubar.vue?vue&type=script&lang=js"
export * from "./menubar.vue?vue&type=script&lang=js"
import style0 from "./menubar.vue?vue&type=style&index=0&id=8398a294&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8398a294",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8398a294')) {
      api.createRecord('8398a294', component.options)
    } else {
      api.reload('8398a294', component.options)
    }
    module.hot.accept("./menubar.vue?vue&type=template&id=8398a294&scoped=true", function () {
      api.rerender('8398a294', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/components/menubar.vue"
export default component.exports